module.exports = __webpack_public_path__ + "static/img/storybook.d1751a37.svg";